module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-mask",
    on: {
      "click": _vm.hideDetail
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("标题：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.detail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("创建时间：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.detail.date))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("状态：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.detail.isDone ? '已完成' : '待处理'))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("内容：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.detail.content))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f29bdb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailDialog.vue
// module id = 33
// module chunks = 0